<section id="submit-and-create-section" data-testid="submit-and-create-section" *ngIf="showSubmitAndCreateSection">
  <div id="subtitle-and-switch">
    <h2 *ngIf="!useCondensed" id="subtitle">{{title}}</h2>
    <h2 *ngIf="useCondensed" id="condensed-subtitle">{{title}}</h2>
    <as-switch *ngIf="!hiddenToggle" data-testid="submit-and-create-toggle" [checkedLabel]="'ON'" [uncheckedLabel]="'OFF'"
      (change)="onChangeToggle($event)" [checked]="!toggleOff"></as-switch>
  </div>
  <span id="submit-and-create-messaging">{{detail}}</span>
  <mm-banners
    *ngIf="(showMissingEmailMessage$ | async) && !isOptedOut && submitAndCreateToggledOn && !showEAuthEmailAddressError && !isOrgAccount && !this.isTrustAccount"
    [bannerText]="[missingEmailMessage]" [type]="'warning'" id="email-banner"
    data-testid="missingEmailMessage"></mm-banners>
  <mm-banners *ngIf="showEAuthEmailAddressError && submitAndCreateToggledOn && !isOptedOut && !isOrgAccount && !this.isTrustAccount"
    [bannerText]="[ineligibleEmailMessage]" [type]="'error'" id="ineligible-eauth-banner"
    data-testid="missingEmailError"></mm-banners>
  <sdps-divider id="bottom-divider" variation="secondary"></sdps-divider>
</section>
